<template>
  <div class="scence" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content">
      <TownName ref="townlist" v-on:townadcd="townAdcd"></TownName>
      <div class="skt" ref="skt">
        <div class="select">
          <span class="xzqh">沿河村落名称:</span>
          <div class="selcountry">
            <el-input v-model="yhcl" clearable placeholder="请输入名称" @change="Global.emptyQuery(yhcl,searchtown)"></el-input>
          </div>
          <span class="xzqh">站名:</span>
          <div class="selcountry">
            <el-input v-model="cz" clearable placeholder="请输入名称" @change="Global.emptyQuery(cz,searchtown)"></el-input>
          </div>
          <span id="search" @click="searchtown">查询</span>
          <span v-if="allowsPerm.delete" id="del" @click="delDialog(multipleSelection)"><span class="del-icon"></span>删除</span>
          <span v-if="allowsPerm.update" id="edit" @click="editDialog"><span class="edit-icon"></span>编辑</span>
          <span v-if="allowsPerm.insert" id="add" @click="addDialog"><span class="add-icon"></span>新增</span>
          <span v-if="allowsPerm.insert" id="add" @click="exportWarnIndex"><span class="export-icon"></span>导出</span>
        </div>
        <div class="tablebox">
          <div class="fzxxtable">
            <el-table ref="multipleTable" @row-click="clickRow" v-loading="loading" :data="tdata" :max-height="height" border @selection-change="handleSelectionChange" style="width: 100%;">
              <el-table-column type="selection" width="40" align="center">
              </el-table-column>
              <el-table-column type="index" width="60"
                               label="序号" align="center"
                               header-align="center"
                               :index='(index)=>{return (index+1) + (pageIndex-1)*pageSize }'>
              </el-table-column>
              <el-table-column  prop="adcdnm" label="行政区划" min-width="180" align="center" >
              </el-table-column>
              <el-table-column prop="villageName" label="沿河村落" min-width="120" align="center" >
              </el-table-column>
              <el-table-column prop="stationName"  label="站名" min-width="180" align="center" >
              </el-table-column>
              <el-table-column prop="warnHours" label="时段（小时）" min-width="150" align="center" header-align="center">
              </el-table-column>
              <el-table-column prop="warnDRP" label="准备转移预警指标（mm）" min-width="150" align="center" header-align="center">
              </el-table-column>
              <el-table-column prop="moveDRP" label="立即转移预警指标（mm)" min-width="150" align="center" header-align="center">
              </el-table-column>
              <el-table-column prop="promptDRP" label="临界雨量(mm)" min-width="150" align="center" header-align="center">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <pager
            @current-change="onCurrentChange"
            @size-change="onSizeChange"
            :pageIndex="pageIndex"
            :pageSize="pageSize"
            :total="total"
        ></pager>
      </div>
    </div>
     <el-dialog
      class="abow_dialog"
      :close-on-click-modal="false"
      :title="status + '预警指标信息'"
      :visible.sync="addbtn">
      <el-form ref="groupForm" :rules="rules" :model="form" label-width="150px" label-height="40px">
        <el-form-item label="行政区划:" prop="adcdid" >
           <el-cascader
           :disabled="adcdidDisabled"
            v-model="form.adcdid"
            :options="mutiRanksAdcd"
            :props="{ expandTrigger: 'hover' }"
           >
          </el-cascader>
        </el-form-item>
         <el-form-item label="测站名称:" prop="stationId">
          <el-select v-model="form.stationId" filterable clearable placeholder="请选择站名">
            <el-option
              v-for="item in stations"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="站名:" prop="stid">
          <el-select
            v-model="form.stid"
            filterable
            clearable
            placeholder="请选择测站">
            <el-option
              v-for="item in stnm"
              :key="item.stid"
              :label="item.stnm"
              :value="item.stid">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="时段:" prop="warnHours">
          <el-input v-model="form.warnHours" :disabled="warnHoursDisabled"></el-input>
          <label>(小时)</label>
        </el-form-item>
        <el-form-item label="准备转移预警指标:" prop="warnDRP">
          <el-input v-model="form.warnDRP"></el-input><label>(mm)</label>
        </el-form-item>
        <el-form-item label="立即转移预警指标:" prop="moveDRP">
          <el-input v-model="form.moveDRP"></el-input><label>(mm)</label>
        </el-form-item>
        <el-form-item label="临界雨量:" prop="promptDRP">
          <el-input v-model="form.promptDRP"></el-input><label>(mm)</label>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addbtn = false">取 消</el-button>
        <el-button type="primary" @click="onGroupSave">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import api from '@/api/scence'
import config from '@/config'
import scenceTypes from '@/store/types/scence'
import monitorTypes from '@/store/types/monitor'
import TownName from '@/components/Townname/index.vue'
import Pager from '@/components/Pager'
export default {
  components: {
    TownName,
    Pager
  },
  data () {
    return {
      cz: '',
      yhcl: '',
      value1: '',
      loading: true,
      loadingSel: false,
      height: 10,
      searchname: '',
      form: {
        adcdid: []
      },
      addbtn: false,
      adcdval: [],
      adcds: [],
      adcdSon: [],
      adcdSonChildren: [],
      stnm: [],
      parentAdcdCode: '',
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      tdata: [],
      isTown: true,
      searchName: '',
      delId: [],
      multipleSelection: [],
      status: '新增',
      secondArea: [],
      thirdArea: [],
      all: true,
      adcdtotal: '',
      towns: [],
      checkarr: [],
      mutiRanksAdcd: [],
      aDCD: '330324',
      stations: [],
      rules: {
        adcdid: [
          { required: true, message: '请选择行政区划', trigger: 'change' }
        ],
        stationId: [
          { required: true, message: '请选择站名', trigger: 'change' }
        ],
        warnHours: [
          { required: true, message: '时段不能为空' },
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        warnDRP: [
          { required: true, message: '准备转移预警指标不能为空' },
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        moveDRP: [
          { required: true, message: '立即转移预警指标不能为空' },
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        promptDRP: [
          { required: true, message: '临界雨量不能为空' },
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ]
      },
      adcdidDisabled: false,
      stidDisabled: false,
      warnHoursDisabled: false
    }
  },
  methods: {
    onSizeChange (pageSize) {
      this.pageIndex = 1
      this.pageSize = pageSize
      this.thedata()
    },
    onCurrentChange (pageIndex) {
      this.pageIndex = pageIndex
      this.thedata()
    },
    // 行政区划选择
    townAdcd: function (townAdcd) {
      this.loading = true
      this.pageIndex = 1 // 查询重置页码
      this.aDCD = townAdcd
      this.thedata()
    },
    getStnm () {
      this.$store.dispatch(scenceTypes.GET_STATIONINFO, { pageIndex: 1, pageSize: 500, sttp: 'PP' }).then(data => {
        this.stnm = data.results
        this.loadingSel = false
      })
    },
    // 获取数据
    thedata () {
      this.loading = true
      this.$store.dispatch(scenceTypes.GET_WARNINDEX, { stationName: this.cz, villageName: this.yhcl, aDCD: this.aDCD, pageIndex: this.pageIndex, pageSize: this.pageSize }).then(data => {
        this.tdata = data.results
        this.total = data.total
        this.loading = false
      })
    },
    towndata () {
      let arr = []
      this.$store.dispatch(monitorTypes.GET_ADCD, {
        isTown: this.isTown,
        searchName: this.searchName,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }).then(data => {
        this.adcdtotal = data.total
        this.towns = data.results
        this.towns.forEach(item => {
          let obj = { adcd: '', adnm: '', id: 0, lat: 0.0, lng: 0.0, modifyTime: '', check: false }
          obj.adcd = item.adcd
          obj.adnm = item.adnm
          obj.id = item.id
          arr.push(obj)
        })
        this.towns = arr
      })
    },
    searchtown () {
      this.pageIndex = 1
      this.thedata()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 新增
    addDialog () {
      this.status = '新增'
      this.form = { adcdid: [] }
      this.adcdidDisabled = false
      this.stidDisabled = false
      this.warnHoursDisabled = false
      this.addbtn = true
      this.Global.clearValidate(this, 'groupForm')
    },
    // 编辑
    editDialog () {
      this.status = '编辑'
      if (this.multipleSelection.length < 1) {
        this.$alert('需要选择一条数据才可进行该操作！请选择其中一条数据。', '提示')
      } else if (this.multipleSelection.length > 1) {
        this.$alert('该操作不可对多条数据同时进行操作。', '提示')
      } else {
        this.form = {}
        this.addbtn = true
        this.form = Object.assign({}, this.multipleSelection[0])
        this.form.adcdid = []
        this.adcdidDisabled = true
        this.stidDisabled = true
        this.warnHoursDisabled = true
        if (this.multipleSelection[0].adcdid !== '' && this.multipleSelection[0] !== undefined) {
          this.getAdcdid(this.mutiRanksAdcd, this.multipleSelection[0].adcdid)
        }
        if (this.multipleSelection[0].stid !== undefined && this.multipleSelection[0].stid !== '') {
          this.form.stid = parseInt(this.multipleSelection[0].stid)
        }
        this.Global.clearValidate(this, 'groupForm')
      }
    },
    // 删除
    delDialog (rows) {
      if (rows < 1) {
        this.$alert('请先勾选需要删除的数据项！', '提示')
      } else {
        this.delId = [] // 清空数组
        rows.forEach(item => {
          this.delId.push(item.relationeId)
        })
        this.$confirm(`确定要删除已选择的预警指标 ?`, '确认').then(() => {
          this.loading = true
          this.$store.dispatch(scenceTypes.DELETE_WARNINDEX, { relationeId: this.delId.join(',') }).then(() => {
            this.loading = false
            this.$notify.success({ title: '成功', message: '删除数据成功.' })
            this.thedata()
          }).catch(() => { this.loading = false })
        }).catch(() => {})
      }
    },
    // 保存新增/编辑
    onGroupSave (type) {
      this.$refs['groupForm'].validate((valid) => {
        if (valid) {
          let adcdidLength = this.form.adcdid.length
          if (adcdidLength > 0) {
            this.form.adcdid = this.form.adcdid[adcdidLength - 1]
          }
          this.loading = true
          this.$store.dispatch(scenceTypes.SAVE_WARNINDEX, this.form).then((res) => {
            if (res.result === 'SUCCESS') {
              this.loading = false
              this.addbtn = false
              this.$notify.success({ title: '成功', message: '保存成功。' })
              this.thedata()
              this.form = {}
            } else {
              this.$notify.error({ title: '失败', message: res.msg })
              this.loading = false
            }
            // this.loading = false
            // this.addbtn = false
            // this.$notify.success({ title: '成功', message: '保存成功。' })
            // this.thedata()
            // this.form = {}
          }).catch(() => {
            this.$notify.error({ title: '失败', message: '保存失败.' })
            this.loading = false
          })
        }
      })
    },
    exportWarnIndex() {
      api.exportWarnIndex({ stationName: this.cz, villageName: this.yhcl, aDCD: this.aDCD, pageIndex: 1, pageSize: 9999 }).then(res => {
        window.open(config.ApiYJ + res.data.data)
      })
    },
    //  行选中
    clickRow (row) {
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    // 获取三级联动数据
    getMutiRanksAdcd () {
      this.$store.dispatch(scenceTypes.GET_MUTIRANKS_ADCD, {
        parentAdcdCode: this.aDCD
      }).then(data => {
        this.mutiRanksAdcd = data.results
      })
    },
    getAdcdid (data, val) {
      for (let index = 0; index < data.length; index++) {
        const element = data[index]
        if (element.value === val) {
          this.form.adcdid.unshift(element.value)
          return true
        } else if (element.children !== undefined && element.children != null) {
          let result = this.getAdcdid(element.children, val)
          if (result) {
            this.form.adcdid.unshift(element.value)
            return true
          }
        }
      }
      return false
    },
    stationdata () {
      this.$store.dispatch(scenceTypes.GET_SITE_MAIN).then(data => {
        this.stations = data.rows
      })
    }
  },
  computed: {
    allowsPerm: {
      get () {
        return this.$store.state.allowPerm
      },
      set () {
        this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
      }
    }
  },
  created () {
    this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
  },
  mounted () {
    this.getStnm()
    this.thedata()
    this.towndata()
    this.stationdata()
    this.getMutiRanksAdcd()
    this.$nextTick(() => {
      let sktDiv = document.getElementsByClassName('skt')
      this.height = sktDiv[0].offsetHeight - 120
    })
  }
}
</script>
<style lang="less" src="@/assets/scene.less" scoped>
.el-select>.el-input {
  width: 202px !important;
}
</style>
<style scoped>
.scence .skt{
  height: calc(100% - 77px);
}
.scence >>> .el-dialog__body {
  height: 70%;
  left: 0;
  top: 54px;
  bottom: 0;
  right: 0;
  z-index: 1;
  overflow: hidden;
  overflow-y: hidden;
}
.scence >>> .el-dialog {
  margin: 0 auto !important;
  /* height: 400px !important; */
}
.scence >>> .el-form-item{
  width: 44% !important;
  margin-left: 25px;
}
/* .scence >>> .el-dialog__footer {
} */
.countryList{
  /* width: 100%; */
  height: 62px;
  background-color: #ffffff;
  border-radius: 5px;
  color: #444444;
  font-size: 15px;
}
.country{
  float: left;
  font-family: Microsoft YaHei UI;
  font-size: 15px;
  text-align: center;
  margin-top: 20px;
  margin-left: 0.5%;
  cursor: pointer;
}
.countryon{
  border-radius: 15px;
  background-color: #fda72c;
  color: #ffffff
}
.country span{
  padding: 4px 15px;
}
</style>
